// =========================================================
// ✅ HELPERS
// =========================================================
function normalizeAbbr(abbr) {
  return abbr?.trim().toLowerCase();
}

function countsAsTeacherWork(angebot) {
  const owners = angebot?.owners || [];

  // open slot
  if (owners.length === 0) {
    return true;
  }

  // at least one real teacher involved
  return owners.some((owner) => {
    const abbr = normalizeAbbr(owner?.abbreviation);
    // return abbr !== "leer" && abbr !== "ubsz";
    return abbr !== "ubsz";
  });
}

// =========================================================
// ✅ COMPUTE TEACHER STATS
// =========================================================
export function computeTeacherStats(teacherWorkloads = {}, angebote = []) {
  // ✅ guard: no schoolyear
  const workloads = teacherWorkloads;

  // ✅ guard: no workloads
  if (!workloads || Object.keys(workloads).length === 0) {
    return { stats: {}, meta: {} };
  }

  const stats = {};

  // =========================================================
  // ✅ 1. INIT
  // =========================================================
  for (const teacherId of Object.keys(workloads)) {
    const key = normalizeAbbr(teacherId);

    stats[key] = {
      actual: 0,
      target: 0,
      delta: 0,
      ratio: 0,
      workload: 0,
    };
  }

  // =========================================================
  // ✅ 2. ACTUAL LOAD + TOTAL ASSIGNMENTS
  // =========================================================
  let totalAssignments = 0;
  let filledSlots = 0;

  for (const angebot of angebote) {
    const owners = angebot?.owners || [];

    if (owners.length > 0) {
      filledSlots += 1;
    }

    totalAssignments += owners.length;

    // ✅ add ACTUAL workload per teacher
    for (const owner of owners) {
      const key = normalizeAbbr(owner?.abbreviation);

      if (!key || !stats[key]) continue; // ✅ guard unknown teacher

      stats[key].actual += 1;
    }
  }

  // =========================================================
  // ✅ 3. TOTAL WORK
  // =========================================================
  const totalSlots = angebote.filter(countsAsTeacherWork).length;

  const noTeacherSlots = angebote.length - totalSlots;

  const extraAssignments = totalAssignments - filledSlots;

  const totalWork = totalSlots + extraAssignments;

  // =========================================================
  // ✅ 4. TOTAL WORKLOAD BASE
  // =========================================================
  const totalWorkload = Object.values(workloads).reduce(
    (sum, t) => sum + (t?.workload || 0),
    0,
  );

  // ✅ guard division
  if (totalWorkload === 0) {
    return {
      stats,
      meta: { totalSlots, totalAssignments, totalWork },
    };
  }

  // =========================================================
  // ✅ 5. TARGET LOAD
  // =========================================================
  for (const [teacherId, t] of Object.entries(workloads)) {
    const key = normalizeAbbr(teacherId);

    if (!stats[key]) continue;

    const workload = t?.workload || 0;

    stats[key].target = (workload / totalWorkload) * totalWork;
    stats[key].workload = workload;
  }

  // =========================================================
  // ✅ 6. FINALIZE
  // =========================================================
  for (const key of Object.keys(stats)) {
    const t = stats[key];

    t.delta = t.actual - t.target;
    t.ratio = t.target > 0 ? t.actual / t.target : 0;
  }

  // =========================================================
  // ✅ RETURN (IMPORTANT CHANGE!)
  // =========================================================
  return {
    stats,
    meta: {
      totalSlots,
      noTeacherSlots,
      totalAssignments,
      totalWork,
      totalWorkload,
    },
  };
}
